import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';

import { localStore } from 'components/Storage';
import { DealerFromStore } from 'components/withDealer';

import {
  logout as authLogout,
  updatePassword as authUpdatePassword,
} from 'auth';

import isEmpty from 'helpers/isEmpty';
import routesPath from 'config/routesPath';

import UserProfileComponent from './UserProfileComponent';

const UserProfileContainer = props => {
  const [state, setState] = useState({
    isOpened: false,
  });

  const currentUser = useSelector(state => state.userStore);

  const isOpenedAnchor = useRef(null);

  const handleToggleisOpened = () => {
    setState(state => ({ isOpened: !state.isOpened }));
  };

  const logout = () => {
    DealerFromStore.clearDealerFromLocalStorage();
    localStore.removeItem('completeLater');
    authLogout();
  };

  const updatePassword = () => authUpdatePassword();

  const handleCallCenterButton = () => {
    const { history } = props;
    if (!isEmpty(currentUser.attributes.callcenter)) {
      DealerFromStore.setDealerGroupToLocalStorage({
        id: currentUser.attributes.callcenter[0],
        name: '',
        active: true,
      });

      history.push(routesPath.callCenter);
      return;
    }
    history.push(`${routesPath.myResellers}?tab=1`);
  };

  const { isConsultantUser, history } = props;

  const viewComponentProps = {
    attributes: currentUser.attributes,
    email: currentUser.email,
    firstName: currentUser.firstName,
    handleCallCenterButton,
    handleToggleisOpened,
    history,
    isConsultantUser,
    isOpened: state.isOpened,
    isOpenedAnchor,
    logout,
    updatePassword,
    username: currentUser.userSiteName,
    userSite: currentUser.userSite,
  };

  return <UserProfileComponent {...viewComponentProps} />;
};

export default UserProfileContainer;
